<div class="row">
    <div class="col-12 col-md-6 col-xl-4">
        <div class="alert alert-info">
            Show the ASP.Net roles with additional privileges allocated to our users.
            <ul>
                <li>Stakeholders get access to runADAPT</li>
                <li>Administrator is a role that should not be allocated to anyone</li>
            </ul>
            We don't list people allocated to the standard ASP.Net User role, since everyone should have that role.
        </div>

        <button class="mt-2"
                adaptButtonIcon
                [adaptBlockingClick]="fetch">Fetch users with privileged ASP.Net roles</button>

        @if (personRoles) {
            <div>
                <dx-data-grid [dataSource]="personRoles"
                              [allowColumnReordering]="true"
                              [allowColumnResizing]="true"
                              [columnAutoWidth]="true"
                              [rowAlternationEnabled]="true">
                    <dxo-data-grid-group-panel [visible]="true"></dxo-data-grid-group-panel>
                    <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
                    <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>
                    <dxo-data-grid-paging [pageSize]="100"></dxo-data-grid-paging>
                    <dxi-data-grid-column dataField="RoleName"
                                          caption="ASP.Net Role"
                                          [groupIndex]="0"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="PersonName"
                                          caption="Person Name"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="PersonId"></dxi-data-grid-column>
                </dx-data-grid>
            </div>
        }
    </div>
</div>
